/**
 * this function inserts, if none, gtag.js script in page head
 * with async=true
 * @param win
 */
export function GA4DeferrableLoader(win, accountId, defer = false) {
    const w = win;
    const maybe = w.document.getElementById("ga4-gtag-scr");
    if (!maybe) {
        w['dataLayer'] = w['dataLayer'] || [];
        if (!('gtag' in w)) {
            w['gtag'] = function () {
                // eslint-disable-next-line prefer-rest-params
                w['dataLayer'].push(arguments);
            };
        }
        return () => {
            const first = win.document.getElementsByTagName('script')[0];
            const scr = win.document.createElement('script');
            if (!defer) {
                scr.async = true;
            }
            else {
                scr.defer = true;
            }
            const useSrc = 'https://www.googletagmanager.com/gtag/js' + (accountId ? `?id=${accountId}` : "");
            scr.src = useSrc;
            scr.id = "ga4-gtag-scr";
            first.parentNode.insertBefore(scr, first);
        };
    }
    else {
        return () => { };
    }
}
